module.exports = __webpack_public_path__ + "img/trade-service-parts-display-honda.0848ce5e.png";